import fetch from '../utils/fetch'
import params from "../view/mall/goods/attributes/params";

// 获取列表
export function getAreaManageList(query) {
  return fetch({
    url: '/setting/areamanage/list',
    method: 'get',
    params: query
  })
}


export function saveAreaManage(params) {
  return fetch({
    url: '/setting/areamanage',
    method: 'post',
    data: params
  })
}

export function updateAreaManage(area_id,query) {
  return fetch({
    url: '/setting/areamanage/'+area_id,
    method: 'put',
    params: query
  })
}

export function deleteAreaManage(id) {
  return fetch({
    url: '/setting/areamanage/delete/'+id,
    method: 'delete'
  })
}
export function newDataAreaManage() {
  return fetch({
    url: '/setting/areamanage/newdatalist',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/areamanage.js